import { render, staticRenderFns } from "./FragmentPrice.vue?vue&type=template&id=71bab410&"
import script from "./FragmentPrice.vue?vue&type=script&lang=ts&"
export * from "./FragmentPrice.vue?vue&type=script&lang=ts&"
import style0 from "./FragmentPrice.vue?vue&type=style&index=0&id=71bab410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports